/* eslint-disable no-unused-vars */
import "./ForgotModal.css";

import { Form, Modal } from "react-bootstrap";
import React, { Fragment, useState } from "react";

import { Link } from "react-router-dom";
// import sendResetEmail from "../../controllers/auth/sendResetEmail";
import UpdateUserInfo from "../../controllers/users/UpdateUserInfo";

// Form Validate imports Start
import {
  // Controller,

  useForm,
} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import GetResetPasswordCode from "../../controllers/auth/GetResetPasswordCode";
import {
  getAuth,
  sendPasswordResetEmail,
  // updatePassword
} from "firebase/auth";
import { AuthErrorMessages } from "../../controllers/auth/AuthErrorMessages";
import { functions } from "../../firebase";
import { httpsCallable } from "firebase/functions";
// Form Validate imports End
let uid = "";
let verified = false;
// Form Validate schema Start
const schema = yup.object().shape({
  email: yup.string().required("Email is Required"),
});
// Form Validate schema End

// Password Reset schema Start
const passwordResetSchema = yup.object().shape({
  password: yup
    .string()
    .min(6, "Password length must be at least 6 characters")
    .required("Password is required!"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords doesn't match!"),
});
const PhoneRegisterSchema = yup.object().shape({
  name: yup.string().min(3).max(200).required(),
  phone: yup.string().required(),
  business: yup.string().min(3).max(200).required(),
});
// Password Reset schema End

const ForgotModal = ({ CheckExistenceOfEmail }) => {
  const {
    register: passwordResetRegister,
    handleSubmit: handleChangePasswordSubmit,
    formState: { errors: passwordResetErrors },
  } = useForm({
    resolver: yupResolver(passwordResetSchema),
  });

  // Form Validate const Start
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    setError,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  // Form Validate const End

  const [Code, setCode] = useState("");
  const [NewPassword, setNewPassword] = useState("");
  const [ConfirmNewPassword, setConfirmNewPassword] = useState("");
  const [Email, setEmail] = useState("");
  const [ErrorMessage, setErrorMessage] = useState(null);

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  const handleChange = (event) => {
    if (!isValidEmail(event.target.value)) {
      setErrorMessage("Email is invalid");
    } else {
      setErrorMessage(null);
    }

    setEmail(event.target.value);
  };

  const [ShowResetModal, setShowResetModal] = useState(false);
  const handleCloseResetModal = () => setShowResetModal(false);
  const handleShowResetModal = () => setShowResetModal(true);

  const [Loading, setLoading] = useState(false);
  const handleStartLoading = () => setLoading(true);
  const handleStopLoading = () => setLoading(false);

  const ResetPassword = async () => {
    if (Email === "") return;
    handleStartLoading();
    // await sendResetEmail(Email);
    // await UpdateUserInfo(Email);
    // handleStopLoading();
    // handleCloseResetModal();
  };

  // Start
  const [ShowVerificationCodeModal, setShowVerificationCodeModal] =
    useState(false);
  const handleCloseVerificationCodeModal = () =>
    setShowVerificationCodeModal(false);

  const handleShowVerificationCodeModal = () =>
    setShowVerificationCodeModal(true);

  const ToVerificationModal = async (e) => {
    // e = watch();
    // if (watch("email") === "") {
    //   handleStartLoading();
    //   handleStopLoading();
    //   return;
    // } else if (await CheckExistenceOfEmail(watch("email"))) {
    //   handleStartLoading();
    //   AuthErrorMessages("auth/user-not-found");
    //   handleStopLoading();
    //   return;
    // } else {
    //   handleStartLoading();
    //   await sendPasswordResetEmail(getAuth(), Email);
    //   uid = await UpdateUserInfo(watch("email"));
    //   handleStopLoading();
    //   setShowResetModal(false);
    //   setEmail(watch("email"));
    //   setShowVerificationCodeModal(true);
    // }

    // e = watch();
    // if (watch("email") === "") {
    //   handleStartLoading();
    //   handleStopLoading();
    //   return;
    // } else if (await CheckExistenceOfEmail(watch("email"))) {
    //   handleStartLoading();
    //   AuthErrorMessages("auth/user-not-found");
    //   handleStopLoading();
    //   return;
    // } else {
    //   handleStartLoading();
    //   await sendPasswordResetEmail(getAuth(), Email);
    //   uid = await UpdateUserInfo(watch("email"));
    //   handleStopLoading();
    //   setShowResetModal(false);
    //   setEmail(watch("email"));
    //   setShowVerificationCodeModal(true);
    // }

    try {
      if (Email === "") {
        return;
      } else {
        await sendPasswordResetEmail(getAuth(), Email);
        handleStartLoading();
        uid = await UpdateUserInfo(Email);
        handleStopLoading();
        setShowResetModal(false);
        setShowVerificationCodeModal(true);
      }
    } catch (error) {
      AuthErrorMessages(error.code);
    }

    // if (Email === "") {
    //   return;
    // } else if (AuthErrorMessages("auth/user-not-found")) {
    //   AuthErrorMessages("auth/user-not-found");
    // } else if (Email !== "" && !AuthErrorMessages("auth/user-not-found")) {
    //   await sendPasswordResetEmail(getAuth(), Email);
    //   handleStartLoading();
    //   uid = await UpdateUserInfo(Email);
    //   handleStopLoading();
    //   setShowResetModal(false);
    //   setShowVerificationCodeModal(true);
    // }

    // setEmail(watch("email"));
    // await sendPasswordResetEmail(getAuth(), Email);
    // handleStartLoading();
    // uid = await UpdateUserInfo(Email);
    // handleStopLoading();
    // setShowResetModal(false);
    // setShowVerificationCodeModal(true);
  };
  // End

  // Start
  const [ShowNewPasswordModal, setShowNewPasswordModal] = useState(false);
  const handleCloseNewPasswordModal = () => {
    setShowNewPasswordModal(false);
  };
  const handleShowNewPasswordModal = () => {
    setShowNewPasswordModal(true);
  };

  const ToSetNewPasswordModal = () => {
    setShowVerificationCodeModal(false);
    setShowNewPasswordModal(true);
  };
  // End

  // Start
  const [
    ShowSuccessfulPasswordResetModal,
    setShowSuccessfulPasswordResetModal,
  ] = useState(false);
  const handleCloseSuccessfulPasswordResetModal = () => {
    setValue("email", "");
    setCode("");
    setValue("password", "");
    setValue("confirmPassword", "");
    setShowSuccessfulPasswordResetModal(false);
  };
  const handleShowSuccessfulPasswordResetModal = () => {
    setShowSuccessfulPasswordResetModal(true);
  };

  const ToSuccessfulPasswordResetModal = () => {
    setShowNewPasswordModal(false);
    setShowSuccessfulPasswordResetModal(true);
  };
  // End

  const verifyCode = async () => {
    setLoading(true);
    if (Code * 1 === (await GetResetPasswordCode(uid)) * 1) {
      ToSetNewPasswordModal();
      verified = true;
    } else {
      AuthErrorMessages("auth/invalid-code");
    }
    setLoading(false);
  };

  const changePassword = async () => {
    try {
      setLoading(true);
      if (NewPassword !== ConfirmNewPassword)
        AuthErrorMessages("auth/passwords-not-matched");
      else {
        const triggerResetPassword = httpsCallable(
          functions,
          "resetUserPassword"
        );
        await triggerResetPassword({ uid, password: NewPassword });
        ToSuccessfulPasswordResetModal();
      }
      setLoading(false);
    } catch (error) {
      AuthErrorMessages();
      console.log(error);
    }
  };

  return (
    <>
      <Link to="#" onClick={handleShowResetModal} className="login-labels">
        Forgot Password?
      </Link>
      <Fragment>
        <Modal
          show={ShowResetModal}
          onHide={handleCloseResetModal}
          keyboard={false}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <p onClick={handleCloseResetModal}>
            <svg
              style={{
                position: "absolute",
                top: "-4px",
                right: "-6px",
                width: "24px",
                height: "24px",
                cursor: "pointer",
              }}
              width="44"
              height="44"
              viewBox="0 0 44 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_216_88)">
                <path
                  d="M22 0C12.046 0 4 8.046 4 18C4 27.954 12.046 36 22 36C31.954 36 40 27.954 40 18C40 8.046 31.954 0 22 0ZM31 24.462L28.462 27L22 20.538L15.538 27L13 24.462L19.462 18L13 11.538L15.538 9L22 15.462L28.462 9L31 11.538L24.538 18L31 24.462Z"
                  fill="black"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_216_88"
                  x="0"
                  y="0"
                  width="44"
                  height="44"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_216_88"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_216_88"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </p>

          <Modal.Body
            style={{
              height: "500px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg
                style={{ margin: "0px 0px 14px 0px" }}
                width="56"
                height="56"
                viewBox="0 0 56 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="28"
                  cy="28"
                  r="28"
                  fill="#4E36A8"
                  fillOpacity="0.2"
                />
                <g clipPath="url(#clip0_216_92)">
                  <path
                    d="M26.2802 36.7971C27.4906 35.9178 28.3607 34.648 28.7439 33.2018C29.127 31.7557 28.9998 30.2216 28.3837 28.8583L30.5944 27.2567L32.1182 29.3601L34.2216 27.8362L32.6977 25.7328L34.8011 24.209L37.087 27.3641L39.1904 25.8402L36.9045 22.6851L37.9562 21.9231L36.4324 19.8197L26.8598 26.7549C25.7564 25.7447 24.3383 25.1459 22.8448 25.0594C21.3512 24.9729 19.8735 25.404 18.6608 26.2801C15.7613 28.3808 15.1114 32.4488 17.2121 35.3483C19.3127 38.2479 23.3807 38.8978 26.2802 36.7971ZM20.1847 28.3835C21.9242 27.1233 24.3654 27.5133 25.6256 29.2528C26.8859 30.9923 26.4959 33.4335 24.7564 34.6937C23.0169 35.954 20.5757 35.564 19.3154 33.8244C18.0552 32.0849 18.4452 29.6438 20.1847 28.3835Z"
                    fill="#4E36A8"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_216_92">
                    <rect
                      width="31.1688"
                      height="31.1688"
                      fill="white"
                      transform="translate(5.96533 24.252) rotate(-35.9229)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <h3 className="modal-heading">Reset your password</h3>
              <p className="modal-sub-text">
                Enter your registered email below to reset the password.
              </p>
            </div>
            <form onSubmit={handleSubmit(ToVerificationModal)}>
              <div className="form-group">
                <label className="modal-form-field-label">Email</label>
                <input
                  type="email"
                  placeholder="Enter Your Email Here"
                  className="form-control  form-input-field"
                  name="email"
                  {...register("email")}
                  onChange={handleChange}
                />
                <p className="errorMessage"> {errors.email?.message} </p>
                {/* <p className="errorMessage">{ErrorMessage && ErrorMessage}</p> */}
              </div>

              <button
                className="form-submit-button py-2"
                type="submit"
                disabled={Loading}
              >
                {Loading ? (
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                ) : (
                  "Submit"
                )}
              </button>
            </form>
          </Modal.Body>
        </Modal>
      </Fragment>

      <Fragment>
        <Modal
          show={ShowVerificationCodeModal}
          onHide={handleCloseVerificationCodeModal}
          keyboard={false}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <p onClick={handleCloseVerificationCodeModal}>
            <svg
              style={{
                position: "absolute",
                top: "-4px",
                right: "-6px",
                width: "24px",
                height: "24px",
                cursor: "pointer",
              }}
              width="44"
              height="44"
              viewBox="0 0 44 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_216_88)">
                <path
                  d="M22 0C12.046 0 4 8.046 4 18C4 27.954 12.046 36 22 36C31.954 36 40 27.954 40 18C40 8.046 31.954 0 22 0ZM31 24.462L28.462 27L22 20.538L15.538 27L13 24.462L19.462 18L13 11.538L15.538 9L22 15.462L28.462 9L31 11.538L24.538 18L31 24.462Z"
                  fill="black"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_216_88"
                  x="0"
                  y="0"
                  width="44"
                  height="44"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_216_88"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_216_88"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </p>

          <Modal.Body
            style={{
              height: "500px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg
                style={{ margin: "0px 0px 14px 0px" }}
                width="56"
                height="56"
                viewBox="0 0 56 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="28"
                  cy="28"
                  r="28"
                  fill="#4E36A8"
                  fillOpacity="0.2"
                />
                <path
                  d="M40 25.7556V35.7778C40 37 39.01 38 37.8 38H20.2C18.99 38 18 37 18 35.7778L18.011 22.4444C18.011 21.2222 18.99 20.2222 20.2 20.2222H31.31C31.244 20.5778 31.2 20.9556 31.2 21.3333C31.2 21.7111 31.244 22.0889 31.31 22.4444H20.2L29 28L33.037 25.4556C33.554 25.9333 34.159 26.3 34.83 26.5444L29 30.2222L20.2 24.6667V35.7778H37.8V26.7778C38.614 26.6111 39.362 26.2444 40 25.7556ZM33.4 21.3333C33.4 23.1778 34.874 24.6667 36.7 24.6667C38.526 24.6667 40 23.1778 40 21.3333C40 19.4889 38.526 18 36.7 18C34.874 18 33.4 19.4889 33.4 21.3333Z"
                  fill="#4E36A8"
                />
              </svg>
              <h3 style={{ fontSize: "26px", fontWeight: 600 }}>
                Check Your Email
              </h3>
              <p style={{ fontSize: "14px", color: "#7c7777" }}>
                We have sent a password reset code to
              </p>
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: 600,
                  color: "#000000",
                  margin: "-18px 0px 14px 0px",
                }}
              >
                {Email}
              </p>
            </div>
            <Form>
              <div className="form-group">
                <label>Verification Code</label>
                <input
                  style={{ height: "60px", backgroundColor: "#f5f5f5" }}
                  type="text"
                  placeholder="Enter Verification Code Here"
                  className="form-control input-style"
                  value={Code}
                  onChange={(e) => setCode(e.target.value)}
                />
              </div>

              <div className="text-center">
                <button
                  style={{ height: "45px" }}
                  type="button"
                  className="btn btn-primary btn-block"
                  // onClick={ResetPassword}
                  onClick={verifyCode}
                  disabled={Loading}
                >
                  {Loading ? (
                    <div className="spinner-border" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : (
                    "Verify"
                  )}
                </button>
              </div>

              <div>
                <p
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "14px 0px 0px 0px",
                  }}
                >
                  Didn't receive an email? Check Your Spam Folder{" "}
                  {/* <span
                    style={{
                      color: "#4E36A8",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: 600,
                    }}
                  >
                    Click To Resend
                  </span> */}
                </p>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      </Fragment>

      <Fragment>
        <Modal
          show={ShowNewPasswordModal}
          onHide={handleCloseNewPasswordModal}
          keyboard={false}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <p onClick={handleCloseNewPasswordModal}>
            <svg
              style={{
                position: "absolute",
                top: "-4px",
                right: "-6px",
                width: "24px",
                height: "24px",
                cursor: "pointer",
              }}
              width="44"
              height="44"
              viewBox="0 0 44 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_216_88)">
                <path
                  d="M22 0C12.046 0 4 8.046 4 18C4 27.954 12.046 36 22 36C31.954 36 40 27.954 40 18C40 8.046 31.954 0 22 0ZM31 24.462L28.462 27L22 20.538L15.538 27L13 24.462L19.462 18L13 11.538L15.538 9L22 15.462L28.462 9L31 11.538L24.538 18L31 24.462Z"
                  fill="black"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_216_88"
                  x="0"
                  y="0"
                  width="44"
                  height="44"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_216_88"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_216_88"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </p>

          <Modal.Body
            style={{
              height: "500px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg
                style={{ margin: "0px 0px 14px 0px" }}
                width="56"
                height="56"
                viewBox="0 0 56 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="28"
                  cy="28"
                  r="28"
                  fill="#4E36A8"
                  fillOpacity="0.2"
                />
                <g clip-path="url(#clip0_219_97)">
                  <path
                    d="M26.2802 36.7971C27.4906 35.9178 28.3607 34.648 28.7439 33.2018C29.127 31.7557 28.9998 30.2216 28.3837 28.8583L30.5944 27.2567L32.1182 29.3601L34.2216 27.8362L32.6977 25.7328L34.8011 24.209L37.087 27.3641L39.1904 25.8402L36.9045 22.6851L37.9562 21.9231L36.4324 19.8197L26.8598 26.7549C25.7564 25.7447 24.3383 25.1459 22.8448 25.0594C21.3512 24.9729 19.8735 25.404 18.6608 26.2801C15.7613 28.3808 15.1114 32.4488 17.2121 35.3483C19.3127 38.2479 23.3807 38.8978 26.2802 36.7971ZM20.1847 28.3835C21.9242 27.1233 24.3654 27.5133 25.6256 29.2528C26.8859 30.9923 26.4959 33.4335 24.7564 34.6937C23.0169 35.954 20.5757 35.564 19.3154 33.8244C18.0552 32.0849 18.4452 29.6438 20.1847 28.3835Z"
                    fill="#4E36A8"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_219_97">
                    <rect
                      width="31.1688"
                      height="31.1688"
                      fill="white"
                      transform="translate(5.96533 24.252) rotate(-35.9229)"
                    />
                  </clipPath>
                </defs>
              </svg>

              <h3 style={{ fontSize: "26px", fontWeight: 600 }}>
                Set New Password
              </h3>
              <p
                style={{
                  fontSize: "14px",
                  color: "#7c7777",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  // margin: "14px 0px 0px 0px",
                }}
              >
                Try to make your password strong by using
                <span>alphabets, numbers and special characters.</span>
              </p>
            </div>
            <form onSubmit={handleChangePasswordSubmit(changePassword)}>
              <div className="form-group">
                <label>Password</label>
                <input
                  style={{ height: "60px", backgroundColor: "#f5f5f5" }}
                  type="Password"
                  name="password"
                  placeholder="********"
                  className="form-control input-style"
                  {...passwordResetRegister("password")}
                  value={NewPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                {/* <p style={{ color: "#7c7777", fontSize: "12px" }}>
                  Must be at least 6 characters
                </p> */}
                <p className="errorMessage">
                  {passwordResetErrors?.password?.message}
                </p>
              </div>

              <div className="form-group">
                <label>Confirm Password</label>
                <input
                  style={{ height: "60px", backgroundColor: "#f5f5f5" }}
                  type="Password"
                  name="confirmPassword"
                  placeholder="********"
                  className="form-control input-style"
                  value={ConfirmNewPassword}
                  {...passwordResetRegister("confirmPassword")}
                  onChange={(e) => setConfirmNewPassword(e.target.value)}
                />
                <p className="errorMessage">
                  {passwordResetErrors?.confirmPassword?.message}
                </p>
              </div>

              <div className="text-center">
                <button
                  style={{ height: "45px" }}
                  // type="button"
                  type="submit"
                  className="btn btn-primary btn-block"
                  // onClick={ResetPassword}
                  // onClick={changePassword}
                  disabled={Loading}
                >
                  {Loading ? (
                    <div className="spinner-border" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : (
                    "Reset Password"
                  )}
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </Fragment>

      <Fragment>
        <Modal
          show={ShowSuccessfulPasswordResetModal}
          onHide={handleCloseSuccessfulPasswordResetModal}
          keyboard={false}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <p onClick={handleCloseSuccessfulPasswordResetModal}>
            <svg
              style={{
                position: "absolute",
                top: "-4px",
                right: "-6px",
                width: "24px",
                height: "24px",
                cursor: "pointer",
              }}
              width="44"
              height="44"
              viewBox="0 0 44 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_216_88)">
                <path
                  d="M22 0C12.046 0 4 8.046 4 18C4 27.954 12.046 36 22 36C31.954 36 40 27.954 40 18C40 8.046 31.954 0 22 0ZM31 24.462L28.462 27L22 20.538L15.538 27L13 24.462L19.462 18L13 11.538L15.538 9L22 15.462L28.462 9L31 11.538L24.538 18L31 24.462Z"
                  fill="black"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_216_88"
                  x="0"
                  y="0"
                  width="44"
                  height="44"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_216_88"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_216_88"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </p>

          {/* <Modal.Header closeButton>
          <Modal.Title>Forgot Password</Modal.Title>
        </Modal.Header> */}
          <Modal.Body
            style={{
              height: "500px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg
                style={{ margin: "0px 0px 14px 0px" }}
                width="156"
                height="110"
                viewBox="0 0 156 110"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="79" cy="82" r="28" fill="#00C93B" />
                <path
                  d="M79 68.875C71.752 68.875 65.875 74.752 65.875 82C65.875 89.248 71.752 95.125 79 95.125C86.248 95.125 92.125 89.248 92.125 82C92.125 74.752 86.248 68.875 79 68.875ZM79 92.8984C72.9824 92.8984 68.1016 88.0176 68.1016 82C68.1016 75.9824 72.9824 71.1016 79 71.1016C85.0176 71.1016 89.8984 75.9824 89.8984 82C89.8984 88.0176 85.0176 92.8984 79 92.8984Z"
                  fill="white"
                />
                <path
                  d="M79 71.1016C72.9824 71.1016 68.1016 75.9824 68.1016 82C68.1016 88.0176 72.9824 92.8984 79 92.8984C85.0176 92.8984 89.8984 88.0176 89.8984 82C89.8984 75.9824 85.0176 71.1016 79 71.1016ZM84.666 77.7139L78.4961 86.2686C78.4099 86.3889 78.2962 86.487 78.1645 86.5546C78.0328 86.6223 77.8868 86.6576 77.7388 86.6576C77.5907 86.6576 77.4448 86.6223 77.3131 86.5546C77.1814 86.487 77.0677 86.3889 76.9814 86.2686L73.3311 81.2061C73.2197 81.0508 73.3311 80.834 73.5215 80.834H74.8955C75.1973 80.834 75.4785 80.9805 75.6543 81.2236L77.7402 84.1182L82.3457 77.7314C82.5215 77.4854 82.8057 77.3418 83.1045 77.3418H84.4785C84.6689 77.3418 84.7803 77.5586 84.666 77.7139Z"
                  fill="black"
                  fillOpacity="0.15"
                />
                <path
                  d="M84.4784 77.3418H83.1044C82.8055 77.3418 82.5214 77.4854 82.3456 77.7314L77.7401 84.1182L75.6542 81.2236C75.4784 80.9805 75.1971 80.834 74.8954 80.834H73.5214C73.3309 80.834 73.2196 81.0508 73.3309 81.2061L76.9813 86.2686C77.0676 86.3889 77.1812 86.487 77.3129 86.5546C77.4447 86.6223 77.5906 86.6576 77.7387 86.6576C77.8867 86.6576 78.0327 86.6223 78.1644 86.5546C78.2961 86.487 78.4097 86.3889 78.496 86.2686L84.6659 77.7139C84.7802 77.5586 84.6688 77.3418 84.4784 77.3418Z"
                  fill="white"
                />
                <circle cx="153" cy="107" r="3" fill="#B4B7B5" />
                <circle cx="3" cy="107" r="3" fill="#4F4F4F" />
                <circle cx="45" cy="51" r="3" fill="#858A86" />
                <circle cx="130" cy="36" r="3" fill="#00C93B" />
              </svg>

              <h3 style={{ fontSize: "26px", fontWeight: 600 }}>
                Successful Password Reset!
              </h3>
              <p style={{ fontSize: "14px", color: "#7c7777" }}>
                Now you can use your new password to log in to your account!
              </p>
            </div>
            {/* <Form action="index-home.html"> */}

            <div className="text-center">
              <button
                style={{ height: "45px" }}
                type="button"
                className="btn btn-primary btn-block"
                disabled={Loading}
                onClick={handleCloseSuccessfulPasswordResetModal}
              >
                {/* {Loading ? (
                    <div className="spinner-border" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : ( */}
                Login
                {/* )} */}
              </button>
            </div>

            {/* </Form> */}
          </Modal.Body>
        </Modal>
      </Fragment>
    </>
  );
};

export default ForgotModal;
